import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import "./Step.css";
import WhiteButton from "../../common_components/common_button/WhiteButton";
import Upload_btn from "./../../common_components/common_button/upload_btn/UploadBtn";
import {
  AllCountry,
  AllDocumentType,
} from "../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import {
  CreateKyc_Step1,
  GetStepsDetail,
} from "../../../features/admin/kycverification/kyc/Slice";
import { setUserId } from "../../../utils/authUser";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const Step1 = ({ formData, setFormData, onNext }) => {
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  const stepDetail = useSelector(
    (state) => state?.kycverification?.kyc?.stepdetail,
  );

  const all_country = useSelector((state) => state?.common?.all_country);
  const all_document_type = useSelector(
    (state) => state?.common?.all_document_type,
  );

  const [frontFile, setFrontFile] = useState(null);
  const [backFile, setBackFile] = useState(null);
  const [frontError, setFrontError] = useState("");
  const [backError, setBackError] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [confirmError, setConfirmError] = useState("");

  const [frontPreview, setFrontPreview] = useState("");
  const [backPreview, setBackPreview] = useState("");

  // ⭐ NEW FLAG (important)
  const [isPrefilled, setIsPrefilled] = useState(false);

  useEffect(() => {
    dispatch(AllCountry());
    dispatch(AllDocumentType());
    dispatch(GetStepsDetail());

    const token = Cookies.get("spirulina_website_security");

    if (token) {
      setUserId(token);
    }
  }, [dispatch]);

  // ⭐ PREFILL ONLY ONCE
  useEffect(() => {
    if (stepDetail && !isPrefilled) {
      const kycData = stepDetail?.kyc_identity_verification;
    

      if (kycData) {
        if (kycData.country_id && all_country?.length) {
          const selectedCountry = all_country.find(
            (c) => c.value === kycData.country_id,
          );
          if (selectedCountry) setValue("country_id", selectedCountry);
        }

        if (kycData.document_id && all_document_type?.length) {
          const selectedDoc = all_document_type.find(
            (d) => d.value === kycData.document_id,
          );
          if (selectedDoc) setValue("document_id", selectedDoc);
        }

        if (kycData.document_front_side) {
          setFrontFile({
            name: kycData.document_front_side.split("/").pop(),
          });
        }

        if (kycData.document_back_side) {
          setBackFile({
            name: kycData.document_back_side.split("/").pop(),
          });
        }

        setIsConfirmed(true);

        // ⭐ stop future prefills
        setIsPrefilled(true);
      }
    }
  }, [stepDetail, all_country, all_document_type, setValue, isPrefilled]);

  // const handleFileChange = (e, side) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   if (side === "front") {
  //     setFrontFile(file);
  //     setFrontError("");
  //     setFormData({ ...formData, frontDocument: file });
  //   } else {
  //     setBackFile(file);
  //     setBackError("");
  //     setFormData({ ...formData, backDocument: file });
  //   }
  // };

  const handleFileChange = (e, side) => {
    const file = e.target.files[0];

    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    if (side === "front") {
      setFrontFile(file);
      setFrontPreview(previewUrl);
      setFrontError("");

      setFormData({
        ...formData,
        frontDocument: file,
      });
    } else {
      setBackFile(file);
      setBackPreview(previewUrl);
      setBackError("");

      setFormData({
        ...formData,
        backDocument: file,
      });
    }
  };

  const handleNextClick = handleSubmit((data) => {
    let isValid = true;

    if (!frontFile) {
      setFrontError("Front document is required");
      isValid = false;
    }

    if (!backFile) {
      setBackError("Back document is required");
      isValid = false;
    }

    if (!isConfirmed) {
      setConfirmError("You must confirm the declaration");
      isValid = false;
    } else {
      setConfirmError("");
    }

    if (!isValid) return;

    const formDataObj = new FormData();

    formDataObj.append("country_id", data.country_id?.value);
    formDataObj.append("document_id", data.document_id?.value);
    formDataObj.append("document_front_side", frontFile);
    formDataObj.append("document_back_side", backFile);

    dispatch(CreateKyc_Step1(formDataObj)).then((res) => {
      if (res?.payload) {
        dispatch(GetStepsDetail());
        onNext();
      }
    });
  });

  const removeFrontPreview = () => {
    setFrontFile(null);
    setFrontPreview("");
    setFrontError("");

    setFormData({
      ...formData,
      frontDocument: null,
    });

    document.getElementById("frontFile").value = "";
  };

  const removeBackPreview = () => {
    setBackFile(null);
    setBackPreview("");
    setBackError("");

    setFormData({
      ...formData,
      backDocument: null,
    });

    document.getElementById("backFile").value = "";
  };

  return (
    <section className="step1-section">
      <div className="title-section">
        <h2 className="step1-title">Step 01: Identity Verification</h2>
        <p className="step1-subtitle">
          Identity verification helps keep your account safe & is required for
          payouts
        </p>
      </div>

      <div className="step1-form">
        <Form onSubmit={handleNextClick}>
          <Row className="mb-4">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="select_title">Select Country</Form.Label>

                <Controller
                  name="country_id"
                  control={control}
                  rules={{ required: "Country is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={all_country}
                      value={field.value}
                      onChange={(val) => field.onChange(val)}
                      onInputChange={(val) => {
                        dispatch(AllCountry(val));
                      }}
                    />
                  )}
                />

                {errors?.country_id && (
                  <Form.Text className="text-danger">
                    {errors?.country_id?.message}
                  </Form.Text>
                )}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label className="select_title">
                  Select Document Type
                </Form.Label>

                <Controller
                  name="document_id"
                  control={control}
                  rules={{ required: "Document Type is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={all_document_type}
                      value={field.value}
                      onChange={(val) => field.onChange(val)}
                      onInputChange={(val) => {
                        dispatch(AllDocumentType(val));
                      }}
                    />
                  )}
                />

                {errors?.document_id && (
                  <Form.Text className="text-danger">
                    {errors?.document_id?.message}
                  </Form.Text>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* File Upload */}
          <Row className="mb-4">
            <Col md={6} className="main-upload-image-box">
              <div className="upload-box">
                <Form.Label className="upload-label">
                  <div className="upload-icon">
                    <img src="./images/step_form/cloud-computing.png" alt="" />
                  </div>
                  <div className="upload-title">
                    Front Side Of Your Document
                  </div>
                  <div className="upload-desc">
                    Upload front side, supports JPEG, PNG, PDF
                  </div>
                </Form.Label>

                <Form.Control
                  type="file"
                  accept="image/jpeg,image/png,application/pdf"
                  onChange={(e) => handleFileChange(e, "front")}
                  className="d-none"
                  id="frontFile"
                />

                <Upload_btn
                  className="upload_btn"
                  title="Choose a File"
                  bgColor="#FFFFFF"
                  color="#010E1E"
                  onClick={() => document.getElementById("frontFile").click()}
                />

                {frontFile && <p className="file-name">{frontFile.name}</p>}

                {frontPreview && (
                  <div className="document-preview">
                    <div className="close-btn" onClick={removeFrontPreview}>
                      <FontAwesomeIcon icon={faXmark} />
                    </div>
                    {frontFile?.type === "application/pdf" ? (
                      <iframe
                        src={frontPreview}
                        title="Front Document"
                        width="100%"
                        height="200px"
                        className="preview-frame"
                      />
                    ) : (
                      <img
                        src={frontPreview}
                        alt="Front Preview"
                        className="preview-image"
                      />
                    )}
                  </div>
                )}

                <div className="error-masage-wrapper">
                  {" "}
                  {frontError && (
                    <Form.Text className="text-danger">{frontError}</Form.Text>
                  )}
                </div>
              </div>
            </Col>

            <Col md={6} className="main-upload-image-box">
              <div className="upload-box">
                <Form.Label className="upload-label">
                  <div className="upload-icon">
                    <img src="./images/step_form/cloud-computing.png" alt="" />
                  </div>
                  <div className="upload-title">Back Side Of Your Document</div>
                  <div className="upload-desc">
                    Upload back side, supports JPEG, PNG, PDF
                  </div>
                </Form.Label>

                <Form.Control
                  type="file"
                  accept="image/jpeg,image/png,application/pdf"
                  onChange={(e) => handleFileChange(e, "back")}
                  className="d-none"
                  id="backFile"
                />

                <Upload_btn
                  className="upload_btn"
                  title="Choose a File"
                  bgColor="#FFFFFF"
                  color="#010E1E"
                  onClick={() => document.getElementById("backFile").click()}
                />
                

                {backFile && <p className="file-name">{backFile.name}</p>}

                {backPreview && (
                  <div className="document-preview">
                    <div className="close-btn" onClick={removeBackPreview}>
                      <FontAwesomeIcon icon={faXmark} />
                    </div>
                    {backFile?.type === "application/pdf" ? (
                      <iframe
                        src={backPreview}
                        title="Back Document"
                        width="100%"
                        height="200px"
                        className="preview-frame"
                      />
                    ) : (
                      <img
                        src={backPreview}
                        alt="Back Preview"
                        className="preview-image"
                      />
                    )}
                  </div>
                )}
                <div className="error-masage-wrapper">
                  {" "}
                  {backError && (
                    <Form.Text className="text-danger">{backError}</Form.Text>
                  )}
                </div>
              </div>
            </Col>
          </Row>

          <Form.Group className="mb-4 confirm-checkbox">
            <Form.Check
              type="checkbox"
              id="confirm"
              label="I confirm that I uploaded a valid government-issued photo ID. This ID includes picture, signature, name, date of birth & address"
              checked={isConfirmed}
              onChange={() => {
                setIsConfirmed(!isConfirmed);
                setConfirmError("");
              }}
            />

            {confirmError && (
              <Form.Text className="text-danger d-block conf-msg">
                {confirmError}
              </Form.Text>
            )}
          </Form.Group>

          <WhiteButton
            className="center-btn"
            title={"Save & Next"}
            bg="#000"
            color="#f35f37"
            hoverColor="#f35f37"
            hoverBg={"#000"}
            type="submit"
          />
        </Form>
      </div>
    </section>
  );
};

export default Step1;
